import {needAuth, noAuh} from "../instance/Instance";


async function getFields() {
    try{
        return  await needAuth.get('/fields');
    }catch (error){
        return error;
    }
}

async function getField(id) {
    try{
        return  await needAuth.get('/fields/'+ id);
    }catch (error){
        return error;
    }
}


async function createFiled(field) {
    try{
        return  await needAuth.post('/fields',field);
    }catch (error){
        return error;
    }
}


async function updateFiled(field) {
    try{
        return  await needAuth.put('/fields',field);
    }catch (error){
        return error;
    }
}

async function deleteFiled(id) {
    try{
        return  await needAuth.delete('/fields/'+id);
    }catch (error){
        return error;
    }
}

async function reorderFields(field) {
    try{
        return  await needAuth.put('/fields/reorder',field);
    }catch (error){
        return error;
    }
}

export {getFields, getField, createFiled, updateFiled, deleteFiled, reorderFields};